import { getTargetPropertyValueLabel } from 'automation-ui-action-features/actions/set-property/utils/getTargetPropertyValueLabel';
import { usePropertyResolver } from 'automation-ui-action-features/actions/set-property/hooks/referenceResolvers';
import CRMPropertyValueTypes from 'automation-ui-flow-core/fields/CRMPropertyValueTypes';
import { isDataToken } from 'automation-ui-formula-editor/data-sources/utils/isDataToken';
import getTokenParts from 'automation-ui-formula-editor/data-sources/utils/getTokenParts';
import { useGetDataProperties } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataProperties';
import getIn from 'immutable-less/transmute/getIn';
import { jsx as _jsx } from "react/jsx-runtime";
export function useTargetProperty({
  actionMetadata,
  associationDefinitionsQuery,
  flowObjectTypeId,
  omitQuotes
}) {
  const targetObjectTypeId = actionMetadata.getTargetObjectTypeId(associationDefinitionsQuery, flowObjectTypeId);
  const {
    data: targetProperty,
    loading,
    error
  } = usePropertyResolver(targetObjectTypeId, actionMetadata.getTargetPropertyName());
  const propertyValue = actionMetadata.getValueValue();
  const dataTokensToResolve = typeof propertyValue === 'string' ? propertyValue.split(';').filter(pValue => isDataToken(pValue)) : [];
  const {
    data: dataTokenProperties,
    loading: dataTokenLoading,
    error: dataTokenError
  } = useGetDataProperties(dataTokensToResolve.map(pValue => {
    const {
      prefix,
      property
    } = getTokenParts(pValue);
    return {
      prefix,
      property
    };
  }));
  const dataTokenLabelsMap = new Map();
  if (targetProperty && targetProperty.type === CRMPropertyValueTypes.ENUM && dataTokenProperties) {
    dataTokensToResolve.forEach(pValue => {
      const {
        prefix,
        property
      } = getTokenParts(pValue);
      const label = getIn([prefix, 'dataSourceProperties', property, 'label'], dataTokenProperties);
      dataTokenLabelsMap.set(pValue, `"${label}"`);
    });
  }
  let targetPropertyValueLabel = getTargetPropertyValueLabel({
    dataTokenLabelsMap,
    omitQuotes,
    property: targetProperty,
    propertyValue
  });
  if (typeof targetPropertyValueLabel === 'number') {
    targetPropertyValueLabel = String(targetPropertyValueLabel);
  }
  return {
    targetObjectTypeId: targetObjectTypeId || null,
    targetProperty,
    targetPropertyLoading: loading || dataTokenLoading,
    targetPropertyError: error || dataTokenError,
    targetPropertyValueLabel
  };
}
const wireTargetProperty = WrappedComponent => props => {
  const injectedProps = useTargetProperty(props);
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, injectedProps));
};
export default wireTargetProperty;